import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow, H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { resources } from '../../data/content';
export function ResourcesSection() {
  return <Section tone="dark" narrow data-id="element-272" data-mp="26z2dsm0r46tj">
      <Eyebrow tone="dark" data-id="element-273" data-mp="2bxna4acvu6cp">But that’s not all</Eyebrow>
      <H2 className="mt-3" data-id="element-274" data-mp="2bx3skur59jz7">You’ll Also Receive Practical Clinical Planning Resources.</H2>
      <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-275" data-mp="1f8o1uvcat4ki">
        Dental Implant Clinical Roadmap™ is designed to be more than a collection of reading material. The system includes reusable educational tools to help you organize and review the information presented throughout the six volumes.
      </p>

      <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-276" data-mp="1t0cbmrz2rgyb">
        {resources.map(r => <li key={r.title} className="flex gap-4 py-5" data-id="element-277" data-mp="vj3vdrjoo8fn">
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-278" data-mp="10hyr1u2r1rh6">
              <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-279" data-mp="1ianli06o3o4x" />
            </span>
            <div data-id="element-280" data-mp="1ea3l8nqss4ek">
              <h3 className="font-display text-lg font-extrabold" data-id="element-281" data-mp="1e9lsi13cg8be">{r.title}</h3>
              <p className="mt-1 text-base leading-relaxed text-white/75" data-id="element-282" data-mp="19gsndc3yqxys">{r.text}</p>
            </div>
          </li>)}
      </ul>

      <p className="mt-8 text-lg font-semibold" data-id="element-283" data-mp="14h6aj3s1rjqi">
        Everything is designed to make the information easier to study, organize, and revisit.
      </p>

      <div className="mt-10" data-id="element-284" data-mp="ujrsizqh6mw3">
        <CtaButton tone="dark" label="I want access to the complete system" note="One-Time Payment of $27 USD" data-id="element-285" data-mp="uji5nl0q8vum" />
      </div>
    </Section>;
}